var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#171926;stroke:#171926;stroke-width:0.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    transform: "translate(-23882 -22480)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23882 22480)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23877 -22475)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.666,13.38a10.309,10.309,0,0,0-3.933-2.467,5.983,5.983,0,1,0-6.77,0A10.365,10.365,0,0,0,0,20.7H1.617a8.732,8.732,0,1,1,17.463,0H20.7A10.281,10.281,0,0,0,17.666,13.38Zm-7.318-3.031a4.366,4.366,0,1,1,4.366-4.366A4.371,4.371,0,0,1,10.349,10.349Z",
    transform: "translate(0)"
  }))))));
};
export default SvgUser;